export default __webpack_public_path__ + "static/expert-financial-insights-60ef677a864b13e1de9b85b5340b79e0.webp";